module.exports = __webpack_public_path__ + "img/kitchen-mobile-active.312a266.svg";